import ZUpload from './upload.vue';

export default ZUpload